<template>
     <div >
   <br><br>
    <button @click="downloadWithAxios">Download file with Axios</button>
  </div>
</template>
   
     
<script>
import axios from 'axios';

export default {
    data(){
        return {
            vslId: this.$route.params.vslId,
        }
    },
    mounted() {
        this.downloadFile();
    },
    methods: {
        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'file.mp4') 
            document.body.appendChild(link)
            link.click()
        },

        downloadWithAxios() {
            axios({
                method: 'get',
                url: this.vslId,
                responseType: 'arraybuffer'
            })
                .then(response => {

                    this.forceFileDownload(response)

                })
                .catch(() => console.log('error occured'))
        },
    }
}
</script>